module.exports = __webpack_public_path__ + "cd121cba49ead774569130f80195d5a5.svg";